import { Product } from "./product.model";

export class ProductCollection {
    name: string;
    products: Array<Product>;

    constructor(collectionName: string, collectionData: Array<any>) {
        this.name = collectionName;
        this.products = collectionData.map(fetchedProduct => {
            return new Product(fetchedProduct);
        })
    }
}


// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/models/product-collection.model.ts